import { render, staticRenderFns } from "./CDOrganizationInformation.vue?vue&type=template&id=13a9adc6&scoped=true"
import script from "./CDOrganizationInformation.vue?vue&type=script&lang=ts"
export * from "./CDOrganizationInformation.vue?vue&type=script&lang=ts"
import style0 from "./CDOrganizationInformation.vue?vue&type=style&index=0&id=13a9adc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9adc6",
  null
  
)

export default component.exports